import React from 'react'
import "./GoogleRatingSection.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay,Pagination  } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';

const testimonialData =[
  {
    clientName: "P Karia",
    clientReview: "The red light therapy provided by Tina assisted my 85 year old mother in reducing pain in her hip and lower back from previous falls. The service lasted six months and became less frequent as time passed. The convenience reduced travel hassles and kept her indoors in the cold winter months. The service provided was effective in improving mobility, as well as professional and friendly!",
    
  },
  {
    clientName: "Sue Gatcke",
    clientReview: "Tina has helped me immensely with laser on my neck. Before we started I was in constant pain and daily headaches. I am now 95 percent pain free and very few headaches. It is also very convenient that she comes to our home for the treatment. Highly recommended to try.",
    
  },
  {
    clientName: "Jillian Babcock",
    clientReview: "I had a wonderful experience with Tina. She is extremely kind and a knowledgeable physiotherapist. I definitely think the laser helped with my pain, inflammation and range of motion following my foot surgery. I was so glad she was able to come to me as I could not drive due to the injury being my right foot.",
    
  },
  {
    clientName: "Jessica Hendriks",
    clientReview: "Tina treated my 88 year old mom with laser therapy for an injury she incurred as a result of a fall. My mom was quite immobile, so the fact Tina came to her retirement home to administer treatment was immensely helpful and convenient. The laser therapy helped alleviate some very jarring pain my mom was experiencing in her lower back. Tina is kind, engaging, patient and abundantly knowledgeable in her field and we would recommend her services to anyone experiencing pain who would prefer the convenience of in-home treatment. Thank you, Tina, for the wonderful care you provided.",
    
  },
  {
    clientName: "lori bowman",
    clientReview: "My son received in home treatment for both a broken wrist as well as for a deep bone bruise and high ankle sprain. He absolutely loved and trusted Tina and looked forward to his sessions with her. He recovered quickly from his injuries and was able to return to his sport and compete without pain. I think his confidence in Tina gave him the confidence that he’d be “ok” to compete sooner than we’d anticipated. The fact that Tina could come to us was super convenient and made the whole experience much nicer for our son. I have referred several people to Tina for various ailments and think this is a great compliment to other modalities, to assist the bodies healing process.",
    
  },
  {
    clientName: "Jt Harland",
    clientReview: "I have had laser therapy a number of times in the past and it has always been an excellent choice for treatment for my back, knee and shoulder pain. It also provides a quick recovery. Mobile therapy is perfect for my schedule and Tina is one of my trusted health providers.",
    
  },
  {
    clientName: "karyn mcbride",
    clientReview: "I injured my lower back and leg and couldn’t sit down as a result due to the pain. Tina came to my home to provide laser therapy as I couldn’t travel by car. The treatment was a lifesaver for me. Even after one session the pain had decreased. I continued with the laser therapy and made a full recovery. Thanks to Tina and her laser therapy treatments.",
    
  },
  {
    clientName: "Pascale Antunes",
    clientReview: "Tina helped me with wound healing and pain after experiencing complications from Achilles repair surgery. She is very flexible with scheduling, experienced and professional. I highly recommend her services!",
    
  },
  {
    clientName: "John Grynol",
    clientReview: "After years of being plagued lower back and shoulder pain due to tendonitis, the bioflex laser system sped up my healing process incredibly. Having Mobile Laser Therapy come to my home was very convenient. I highly recommend Mobile Laser Therapy if you need expedited healing and pain relief.",
    
  },
  {
    clientName: "Bob Maloney",
    clientReview: "Great service in the convenience of your home. My shoulder required laser treatment and I was able to successfully treat at home during convenient times. Back on the golf course and swinging soon after treatments. Thanks Tina!",
    
  },
  {
    clientName: "Elena Nagy",
    clientReview: 'I had very nice experience with " Mobile Laser Therapy" Tina was very knowledgeable and helped me to recover very fast using bioflex laser.Thank you Tina !',
    
  },

];


function GoogleRatingSection() {
  return (
    <div className='GoogleRatingSection-container standard-margin-space mt-0 pb-0 mb-0'>
        <div className='container py-5 px-5'>
          <h3 className='body-heading text-center mt-4' style={{textTransform:"uppercase"}}>What Our Clients Say About Us</h3>
          {/* <h3 className='body-heading text-center mt-4'>TRUST WE'VE EARNED</h3> */}
          {/* <h6 className='text-center my-3 mb-5'>What Our Client Say About Us</h6> */}
            <div className='d-flex flex-lg-row flex-column gap-5 align-items-center justify-content-between'>
                <img src='/images/icons/google-review.png' alt='google review' className='google-review-icon'/>

                <button className='genral-btn' onClick={()=>{window.open("https://www.google.com/search?sa=X&sca_esv=e5ef21b71770b976&rlz=1C1CHBF_enPK1095PK1095&cs=1&hl=en&biw=1440&bih=739&tbm=lcl&sxsrf=AHTn8zozX7mWaR0ve4tfTWUtSpW9_k5zcg:1739892298572&q=Mobile%20Laser%20Therapy%20Reviews&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDcyMTCxsDQ3NDIwBtIWppZGGxgZXzHK-OYnZeakKvgkFqcWKYRkpBYlFlQqBKWWZaaWFy9ixSsNAF2XECBZAAAA&rldimm=17240489712034898592&ved=0CAgQ5foLahcKEwjY1Nf1w82LAxUAAAAAHQAAAAAQBQ#lkt=LocalPoiReviews&arid=ChdDSUhNMG9nS0VJQ0FnTUNBal82aWhBRRAB")}}>
                  see more</button>
            </div>
            <div className='testimonial-list'>
            <Swiper
                spaceBetween={20}
                navigation={{
                nextEl: '.swiper-button-next-test',
                prevEl: '.swiper-button-prev-test',
                }}
                loop={true}
                autoplay={
                {
                    delay:4500,
                    disableOnInteraction:false
                }
                }
                // modules={[Autoplay,Pagination]}
                modules={[Autoplay]}
                pagination={{ clickable: true }}
                observer ={true}
                observeParents={true}
                parallax={true} 
                
                breakpoints={{
                    280: {
                    slidesPerView: 1,
                    },
                    993: {
                    slidesPerView: 3,
                    }
                }}
                className="testimonials-list py-5 mt-2"
                style={{position:"relative"}}
                id="test-cards-slider"
                    >
                   
                        {
                        testimonialData.map((clientData,ind)=>{
                        return(<>
                            <SwiperSlide key={ind} className="pt-5 px-3 px-sm-0">
                            <TestimonialCard clientImg={clientData.clientImg} clientName={clientData.clientName} clientReview={clientData.clientReview}/>
                            </SwiperSlide>
                            
                            </>)
                        })
                    }
                   
                </Swiper>
            </div>
        </div>
    </div>
  )
}

function TestimonialCard(props)
{
  const pastelColors = [
    "#FFB6C1", // Light Pink
    "#FFD700", // Gold
    "#90EE90", // Light Green
    "#87CEFA", // Light Sky Blue
    "#FF69B4", // Hot Pink
    "#FFA07A", // Light Salmon
    "#8A2BE2", // Blue Violet
    "#20B2AA", // Light Sea Green
    "#FF6347", // Tomato
    "#6495ED"  // Cornflower Blue
  ];
  
  function getRandomPastelColor() {
    return pastelColors[Math.floor(Math.random() * pastelColors.length)];
  }
    const paragraphs = props.clientReview.split('\n').map((paragraph, index) => <p key={index} className={`review-text color-dark px-2`}>{paragraph}</p>);
 
    return(
        <div className="testimonial-card">
            <div className='d-flex align-items-center gap-3'>
                {
                  props.clientImg ?
                    <img src={props.clientImg} alt="user" className="user-img" />
                    :
                    <div 
                      className='img-placeholder d-flex align-items-center justify-content-center'
                      style={{backgroundColor:`${getRandomPastelColor()}`}}
                    >
                      <h3 className='mb-0' >{props.clientName[0]}</h3>
                      </div>
                }
                <div className='d-flex flex-column'>
                    <h6 className='clientName-text'>{props.clientName}</h6>
                    <img src='/images/icons/star-icon.png' alt='star group' className='star-icons' />
                </div>
            </div>
       <div className="testimonial-card-info pb-2">
            <div className="profile-info px-2 w-100">
                <p className="review-text body-paragraph review-text-main mt-2 color-dark ">{paragraphs}</p>
            </div>
        </div>
    </div>
    )
}

export default GoogleRatingSection